import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_REQUEST_QUERY = graphql(/* GraphQL */ `
  query TsrctContractDemandRequest($id: UUID!) {
    tesseract {
      contractDemand(id: $id) {
        id
        status
        demandRequest {
          id
          currency
          lineItems {
            id
            createdAt
            title
            description
            deliveryLocationId
            organizationId
            unitId
            quantity
            commodityGroupId
            commodityId
            baselinePricePerUnit
            baselinePricePerPriceUnit
            minimumOrderQuantity
            priceUnit
            qualifiedSuppliers
            totalValue
          }
        }
      }
    }
  }
`);
